import React from 'react';
import { InfoModal, InfoModalProps } from '../../../../theme/components';
import CreateReport, { CreateReportProps } from './CreateReport';

function ModalCreateReport(props: InfoModalProps & CreateReportProps) {
  return (
    <InfoModal {...props} maxWidth="md" fullWidth>
      <CreateReport {...props} />
    </InfoModal>
  );
}

export default ModalCreateReport;
